import { inject, Injectable } from '@angular/core';
import { SnackbarService } from '@digipay/ngx-snackbar';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  snackbarService = inject(SnackbarService);

  showErrorMessage(message: string, description?: string): void {
    this.snackbarService.openSnackBar({ message: message, description: description, status: 'error' });
  }

  showWarningMessage(message: string): void {
    this.snackbarService.openSnackBar({ message: message, status: 'warning' });
  }

  showWarningMessageWithDescription({ message, description }: { message: string; description: string }): void {
    this.snackbarService.openSnackBar({ message, status: 'warning', description });
  }

  showSuccessMessage(message: string): void {
    this.snackbarService.openSnackBar({ message: message });
  }

  showErrorOfErrorResponse(error: any, defaultMessage = 'خطای فنی به وجود آمده، لطفا دوباره سعی کنید', description?: string): void {
    this.showErrorMessage(error?.error?.result?.message || error?.result?.message || defaultMessage, description);
  }

  showInfoMessage(message: string): void {
    this.snackbarService.openSnackBar({ message: message, status: 'info' });
  }
}
